import { render, staticRenderFns } from "./PopupDataRequired.vue?vue&type=template&id=106dcd33"
import script from "./PopupDataRequired.vue?vue&type=script&lang=js"
export * from "./PopupDataRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports